<template>
    <v-content>
        <component  :is="componentname"  ></component>
    </v-content>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
    export default {
        components: {
            cal1: ()=>import('@/views/Calendar.vue'),
            cal2: ()=>import('@/views/Calendar2.vue')
        },
        name: "Index",
        data() {
            return {
                cal:true
            }
        },
        computed:{
            componentname(){
                return (this.cal)?'cal1':'cal2'
            }
        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style scoped>
    .ol{
        border:solid thin green
    }
</style>